<template>
  <div class="flex-column">
    <div class="contact-detail-header px-1 py-2">
      <!-- <el-select v-model="selectedTab" @change="handleSelectTab" size="mini" class="w-150px">
        <el-option v-for="sort in listRecommendTab" :key="sort.val" :label="sort.name"
                   :value="sort.val"></el-option>
      </el-select> -->
      <div class="d-flex justify-content-between align-items-center">
        <!-- Vòng lặp v-for bên trái -->
        <div class="d-flex">
          <div v-for="sort in listRecommendTab" :key="sort.val" class="me-2">
            <el-button @click="selectedTab = sort.val; handleSelectTab()" v-bind:style="getMenuStyle(sort)" style="border: none;">
              {{ sort.name }} ({{ numberOfType(sort.val) }})
            </el-button>
          </div>
        </div>

        <!-- Phần tử căn phải -->
        <div class="d-flex align-items-center">
          <el-input prefix-icon="el-icon-search" @input="requestedFriendsList" placeholder="Tìm kiếm..." class="mx-2  contact-input"
                v-model="searchKey" style="width: 406px;"></el-input>
                <div class="d-flex justify-content-between align-items-center">
        </div>
        </div>
      </div>
    </div>
    <div class="divider-custom" />
    <div class="contact-item-list flex-1">
      <div class="" v-for="request in requestedFriendsView" :key="request.userId">
        <div class="bg-white">
          <div class="contact-item py-3 px-3">
            <el-avatar :size="52" :src="request.avatar"></el-avatar>
            <div class="flex-1">
              <div class="d-flex align-items-center font-size-16 fw-semibold mx-3">
                <span class="text-1-line">{{ request.displayName }}</span>
                <span class="font-size-14 text-1-line mx-2" v-if="request.time!=-1" style="color: #ABAEBB; font-weight: 400;">
                 | {{ request.type === "recommend" ? formatDateTimeShort(Number(request.time)) : formatDateTimeShort(Number(request.time + "000")) }}<i class="fa-thin fa-message-captions"></i>
                </span>
              </div>
              <div class="mt-1 font-size-15 text-1-line mx-3 d-flex" v-if="request.message">
                <div style="font-weight: bold; margin-right: 5px;">Bạn: </div>{{ request.message }}
              </div>
            </div>
            <el-button v-if="request.type=='recommend'" type="success"
                       @click="acceptRequest(request)"><i class="fa-sharp-duotone fa-solid fa-check"></i>
            </el-button>
            <el-button v-if="request.type=='recommend'" type="default" plain
                       @click="rejectRequest(request)"><i class="fa-duotone fa-solid fa-x" style="color: #ff0000;"></i>
            </el-button>
            <el-button v-if="request.type=='request'" type="default" plain
                       @click="undoFriendRequest(request)"><span class="font-size-14" style="color: #CF4547;">Thu hồi lời mời</span>
            </el-button>
          </div>
        </div>
        <div class="divider-custom " />
      </div>

    </div>
    <div class="d-flex justify-content-center  mt-2">
      <el-pagination
        v-if="pageInfo.total > 1"
        background
        layout="prev, pager, next"
        :current-page="pageInfo.page"
        :total="pageInfo.total"
        :page-size="pageInfo.pageSize"
        @current-change="currentRequestPageChanged"
        @prev-click="pageInfo.page -= 1"
        @next-click="pageInfo.page += 1"
      ></el-pagination>

    </div>
  </div>
</template>

<script>
export default {
  name: "ContactListRecommend",
  props: ["selectedAccount"],
  watch: {
    selectedAccount: function() {
      this.getRecommendFriends();
      this.getRequestedFriends();
    }
  },
  data() {

    return {
      requestedFriends: [],
      friendRequests: [],
      listRecommendTab: [
        { name: "Lời mời đã nhận", val: 1 },
        { name: "Lời mời đã gửi", val: 2 }],
      selectedTab: 1,
      pageInfo: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      requestedFriendsView: [],
      searchKey: "",
      countRequestedFriend : 0,
      countFriendRequests: 0,

    };
  },
  methods: {
    searchByName() {

    },
    currentRequestPageChanged(newPage) {
      this.pageInfo.page = newPage;
      this.requestedFriendsList();
    },

    undoFriendRequest(request) {
      let userId = request.userId;
      this.$http.get("/api/contact/undoFriendRequest", {
        params: {
          accountId: this.selectedAccount,
          userId: userId
        }
      }).then((resp) => {
        if (resp.data.error_code === 0) {
          this.alert("success", "Thao tác thành công");
          this.getRequestedFriends();
        }
        if (resp.data.error_code !== 0) {
          this.alertError(resp.data.error_message);
        }
      });
    },
    acceptRequest(request) {
      let userId = request.userId;
      this.$http.get("/api/contact/acceptRequest", {
        params: {
          accountId: this.selectedAccount,
          userId: userId
        }
      }).then(() => {
        this.alert("success", "Thao tác thành công");
        this.getRecommendFriends();
      });
    },
    rejectRequest(request) {
      let userId = request.userId;
      this.$http.get("/api/contact/rejectRequest", {
        params: {
          accountId: this.selectedAccount,
          userId: userId
        }
      }).then(() => {
        this.alert("success", "Thao tác thành công");
        this.getRecommendFriends();
      });
    },
    getRecommendFriends() {
      this.$http
        .get("/api/contact/recommendFriend", {
          params: {
            accountId: this.selectedAccount
          }
        })
        .then(resp => {
          let recommItems = resp.data.data?.recommItems || [];
          this.friendRequests = recommItems.filter(i => i.dataInfo.recommType == 2);
          this.requestedFriendsList();
        });
    },
    getRequestedFriends() {
      this.$http
        .get("/api/contact/requestedFriends", {
          params: {
            accountId: this.selectedAccount
          }
        })
        .then(resp => {
          let data = resp.data.data;
          this.requestedFriends = [];
          if (data !== null && data != {}) {
            for (const key of Object.keys(data)) {
              this.requestedFriends.push(data[key]);
            }
          }
          this.requestedFriendsList();
        });
    },
    handleSelectTab() {
      this.pageInfo.page = 1;
      this.requestedFriendsList();
    },
    requestedFriendsList() {
      this.requestedFriendsView = [];
      let view = [];

      this.friendRequests.forEach((item) => {
        view.push({
          avatar: item.dataInfo.avatar,
          displayName: item.dataInfo.displayName,
          userId: item.dataInfo.userId,
          time: item.dataInfo.recommTime,
          message: item.dataInfo.recommInfo.message,
          type: "recommend"
        });
      });

      this.requestedFriends.forEach((item) => {
        view.push({
          avatar: item.avatar,
          displayName: item.displayName,
          userId: item.userId,
          time: item.fReqInfo.time,
          message: item.fReqInfo.message,
          type: "request"
        });
      });

      this.countFriendRequests = view.filter((c) => c.type === "recommend").length;
      this.countRequestedFriend = view.filter((c) => c.type === "request").length;
      this.app.contactTotal.recommend = view.length;
      if (this.searchKey) {
        view = view.filter((c) => c.displayName.includes(this.searchKey.toLowerCase()) || (c.displayName != null && c.displayName.toLowerCase().includes(this.searchKey.toLowerCase())));
        this.countFriendRequests = view.filter((c) => c.type === "recommend").length;
        this.countRequestedFriend = view.filter((c) => c.type === "request").length;
      }
      if (this.selectedTab == 1) {
        view = view.filter((c) => c.type == "recommend");
      }
      if (this.selectedTab == 2) {
        view = view.filter((c) => c.type == "request");
      }
      this.pageInfo.total = view.length;
      this.requestedFriendsView = view.slice((this.pageInfo.page - 1) * this.pageInfo.pageSize, this.pageInfo.page * this.pageInfo.pageSize);
      
    },
    numberOfType(str){
      if(str === 1) return this.countFriendRequests;
      if(str === 2) return this.countRequestedFriend;
    },
    getMenuStyle(type) {
      return type.val == this.selectedTab ? this.activeMenuStyle("#1A6B44") : this.normalMenuStyle("#696B72");
    },
    activeMenuStyle(color) {
      //#0A58C0
      return {
        "border-radius": "4px",
        //   border: "2px solid " + this.setTransparencyHex(color, 0.1),
        "font-weight": "bold",
        color: color,
        "background-color": this.setTransparencyHex(color, 0.1)
      };
    },
    normalMenuStyle(color) {
      //#696B72
      return {
        //   "border-radius": "4px",
        //   border: "2px solid " + this.setTransparencyHex(color, 0.1),
        color: color,
        "font-weight": "500",
        "background-color": "transparent"
      };
    },

  },
  created() {
    if (this.selectedAccount) {
      this.getRecommendFriends();
      this.getRequestedFriends();
    }
  }
};

</script>

<style scoped>
.contact-item:hover {
  background-color: #F5F9FE;
  cursor: pointer;
}
</style>